import { render } from "./ThreeCircles.vue?vue&type=template&id=f2b11e66&scoped=true"
import script from "./ThreeCircles.vue?vue&type=script&lang=js"
export * from "./ThreeCircles.vue?vue&type=script&lang=js"

import "@/assets/css/circlestyles.css?vue&type=style&index=0&id=f2b11e66&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b11e66"]])

export default __exports__